import { useSelector } from "react-redux";
import "./RiBatches.scss";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  TablePagination,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { IoIosRefresh, IoMdAdd } from "react-icons/io";
import { CiImageOn } from "react-icons/ci";
import { MdClose, MdEmail, MdOutlineNumbers, MdPhone } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoDocumentTextSharp } from "react-icons/io5";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { useNavigate } from "react-router-dom";
import { getCssValue, getRiAllocationValue } from "../../../utils/genericFunctions";
import { showToast } from "../../../toastService";
import { useTranslation } from "react-i18next";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";

const RiBatches = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [confirmationActiontext, setConfirmationActiontext] = useState("");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [searchTerm, setSearchTerm] = useState("");
  const [allRiBatches, setAllRiBatches] = useState([]);
  const [riBatches, setRiBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: ""
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentBatchPage, setCurrentBatchPage] = useState(0);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [channelTypes, setChannelTypes] = useState([]);

  const [reportGroupArray, setReportKeysArray] = useState(["ri-batcheses"]);
  // reports
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);


  // claims
  const handleBatchPageChange = (event, newPage) => {
    setCurrentBatchPage(newPage);
  };

  const handleBatchRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentBatchPage(0);
  };


  const filteredBatches = riBatches?.filter(
    (row) =>
      row?.ri_batch_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.ri_policy_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.ri_endorsement_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.ri_risk_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.ri_treaty_code?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const paginatedBatches = filteredBatches?.slice(
    currentBatchPage * rowsPerPage,
    currentBatchPage * rowsPerPage + rowsPerPage
  );

  const fetchBatches = async (firstTime) => {
    try {
      if (firstTime) {
        setIsLoading(true);
      } else {
        setIsProcessing(true);
      }
      const res = await newRequest.post("/ribatch/findAll",
        {
          ri_batch_no: "",
          ri_policy_no: "",
          ri_endorsement_no: "",
          result_limit: 20,
        });
      setAllRiBatches(res.data);
      setRiBatches(res.data);
      setIsLoading(false);
      setIsProcessing(false);
    } catch (error) {
      setIsLoading(false);
      setIsProcessing(false);
    }
  };

  const fetchChannelTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Channel Type" });
      const options = [{ _id: "All", sys_code: "All", sys_name: "All", sys_desc: "View all" }, ...res.data];
      setChannelTypes(options);
      setSelectedChannel(options[0]);
    } catch (err) {
      console.log(err);
    }
  };


  const handleSearchBatches = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/ribatch/search",
          {
            search_input: searchTerm
          });
        setRiBatches(res.data);
      } else {
        fetchBatches();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBatches(true);
    fetchChannelTypes();
  }, []);

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "openVisit") {

      }

    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  return (
    <div className="ri-batches">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="ri-batches-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="ri-batches-center-wrapper">
            <div className="center-navbar">
              <div className="navbar-left">
                <span className="page-title">{t('riBatches').toUpperCase()}</span>
              </div>
              <div className="navbar-right">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#2563EB"
                  tooltip="Run RI reports"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0f766e5d"
                  endIcon={<IoIosRefresh />} onClick={fetchBatches}>
                  {t('refresh')}
                </CustomLoadingButton>
              </div>
            </div>
            <div className="center-content">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                          <span>{t('no').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                          <div className="search-input-wrapper" style={{ display: "flex", width: "100%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder={`${t('search')} ${t('batch')}`}
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSearchBatches();
                              }}
                            />
                            {searchTerm?.length > 0 && (
                              <MdClose
                                onClick={async (e) => {
                                  try {
                                    setSearchTerm("");
                                    await fetchBatches();
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                className="search-input-icon"
                              />
                            )}
                            {searchTerm?.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                          <span />
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                          <span>{t('status')}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {paginatedBatches?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedBatch?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedBatch(row);
                              navigate(`/ri/${row._id}`);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentBatchPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                            <span className="sub-title">{row?.ri_batch_no}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div className="insured-details">
                              {row?.pl_assr_photo_url_xx ?
                                <img src={row?.pl_assr_photo_url_xx} alt="" className='insured-avatar' />
                                :
                                <InitialsAvatar
                                  name={row?.pl_assr_name_xx || "System"}
                                  size={30}
                                  currentTheme={currentTheme}
                                />
                              }
                              <div className="insured-name">
                                <h1 className="sub-title nowrap">{row?.pl_assr_name_xx}</h1>
                                <div className="insured-contact">
                                  <span style={{ display: "flex", flex: "1", justifyContent: "flex-start", }}><MdOutlineNumbers className="icon" /> <h1 className="sub-title xrsmall">{row?.pl_assr_ent_code}</h1></span>
                                  <span style={{ display: "flex", flex: "2", justifyContent: "flex-start", }}><MdEmail className="icon" />  <h1 className="sub-title xrsmall">{row?.pl_assr_email_xx || "Unspecified"}</h1></span>
                                  <span style={{ display: "flex", flex: "1", justifyContent: "flex-start", alignSelf: "flex-end" }}><MdPhone className="icon" />  <h1 className="sub-title xrsmall">{row?.pl_assr_phone_no_xx || "Unspecified"}</h1></span>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                            <div style={{ display: "flex", flexDirection: "row", width: "150px", gap: "5px" }}>
                              <span className={`status ${getRiAllocationValue(row?.ri_allocation_mode)}`} style={{ width: "2px" }} />
                              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span className="sub-title">{row?.ri_allocation_mode}</span>
                                <span className="sub-title xrsmall soft">{row?.time_ago_xx}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            <span className={`sub-title xrsmall status ${getCssValue(row?.ri_status)}`}>{row?.ri_status}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {riBatches?.length > riBatches?.length &&
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleBatchRowsPerPage}
                      component="div"
                      count={riBatches?.length}
                      rows={riBatches}
                      page={currentBatchPage}
                      onPageChange={handleBatchPageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
          <div className="ri-batches-right-wrapper">
            <div className="options-list">
              {channelTypes?.map((row) => (
                <span
                  key={row._id}
                  className={`${selectedChannel?._id === row._id
                    ? "single-option active"
                    : "single-option"
                    }`}
                  onClick={async () => {
                    try {
                      if (row?.sys_code === "All") {
                        await fetchBatches();
                        setSelectedChannel(row);
                      } else {
                        setSelectedChannel(row);
                        const filteredBatches = allRiBatches.filter(
                          (batch) => batch?.pl_channel === row?.sys_code
                        );
                        setRiBatches(filteredBatches);
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <h1 className="sub-title">{row?.sys_name}</h1>
                  <h1 className="sub-title soft">{row?.sys_code}</h1>
                </span>
              ))}
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docId: "1",
                  docType: "AllClaim",
                  format: "xlsx",
                  entity_code: "",
                  date_fm: "",
                  date_to: "",
                  status: "",
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t("confirmation")}
        dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
      />
    </div>
  )
}

export default RiBatches